<template>
  <div>
    <div class="columns">
      <div class="column" style="position: relative; height: 50px">
        <div class="columns">
          <div class="column is-12">
            <div class="columns is-mobile">
              <div class="column">
                <b-tooltip
                  type="is-dark"
                  position="is-right"
                  :label="$translate('copy_dx_in_sx') | capitalize"
                  multilined
                >
                  <a :disabled="disabledbool" class="button is-primary" @click="copyToOtherFoot('right')">
                    <b-icon icon="content-copy" />
                  </a>
                </b-tooltip>
              </div>
              <div class="column is-11">
                <h3 class="subtitle green">
                  {{ $translate('left_foot') | uppercase }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column" style="position: relative; height: 50px">
        <div class="columns">
          <div class="column is-12">
            <div class="columns is-mobile">
              <div class="column is-11">
                <h3 class="subtitle green has-text-right">
                  {{ $translate('right_foot') | uppercase }}
                </h3>
              </div>
              <div class="column is-1">
                <b-tooltip
                  type="is-dark"
                  position="is-left"
                  :label="$translate('copy_sx_in_dx') | capitalize"
                  multilined
                >
                  <a class="button is-primary" :disabled="disabledbool" @click="copyToOtherFoot('left')">
                    <b-icon icon="content-copy" />
                  </a>
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="!shapes || !shapes.length">
      Selezionare una suola
    </p>
    <div v-else class="columns is-centered">
      <div class="column is-narrow">
        <table class="bordered-table dynamic dynamic--no-padding">
          <thead>
            <tr>
              <th></th>
              <th :colspan="shapes.length">
                <b-field :message="errors.first('left-size')" :type="{ 'is-danger': errors.has('left-size') }">
                  <b-select
                    v-validate="'required'"
                    :disabled="disabledbool"
                    @input="setSize('left')"
                    v-model="selectedSize.left"
                    placeholder="Scegli una taglia"
                    name="left-size"
                  >
                    <option v-for="size in availableSizes" :key="`left-${size}`" :value="size">{{ size }}</option>
                  </b-select>
                </b-field>
              </th>
              <th>{{ $translate('size') | capitalize }}</th>
              <th :colspan="shapes.length">
                <b-field :message="errors.first('left-size')" :type="{ 'is-danger': errors.has('right-size') }">
                  <b-select
                    v-validate="'required'"
                    :disabled="disabledbool"
                    @input="setSize('right')"
                    v-model="selectedSize.right"
                    placeholder="Scegli una taglia"
                    name="right-size"
                  >
                    <option v-for="size in availableSizes" :key="`right-${size}`" :value="size">{{ size }}</option>
                  </b-select>
                </b-field>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Paziente</strong></td>
              <td v-for="shape in orderedByFitCodeShapes" :key="`left-shaped-code-label-${shape.id}`">
                <b-field
                  :message="errors.first(`left-${shape.fit_code}`)"
                  :type="{ 'is-danger': errors.has(`left-${shape.fit_code}`) }"
                >
                  <b-radio-button
                    @input="$emit('update', values, [shape, 'left'])"
                    v-model="values.left.fit_code"
                    :disabled="disabledbool"
                    :native-value="shape.fit_code"
                    type="is-primary is-light is-outlined"
                    v-validate="'required'"
                    :name="`left-${shape.fit_code}`"
                  >
                    <strong>{{ shape.fit_code }}</strong>
                  </b-radio-button>
                </b-field>
              </td>
              <td><strong>Codice Calzata</strong></td>
              <td v-for="shape in orderedByFitCodeShapes" :key="`right-shaped-code-label-${shape.id}`">
                <b-field
                  :message="errors.first(`right-${shape.fit_code}`)"
                  :type="{ 'is-danger': errors.has(`right-${shape.fit_code}`) }"
                >
                  <b-radio-button
                    @input="$emit('update', values, [shape, 'right'])"
                    v-model="values.right.fit_code"
                    :disabled="disabledbool"
                    :native-value="shape.fit_code"
                    type="is-primary is-light is-outlined"
                    v-validate="'required'"
                    :name="`right-${shape.fit_code}`"
                  >
                    <strong>{{ shape.fit_code }}</strong>
                  </b-radio-button>
                </b-field>
              </td>
              <td><strong>Paziente</strong></td>
            </tr>
            <tr v-for="(header, index) in shapeTableHeaders" v-bind:key="header">
              <td>
                <b-field
                  :message="errors.first(`left-${header}`)"
                  :type="{ 'is-danger': errors.has(`left-${header}`) }"
                >
                  <b-input
                    v-validate="`${config.isMeasurementRequired(header) ? 'required|' : ''}between:0,999|integer`"
                    :placeholder="'misure mm'"
                    :disabled="!selectedSize.left || disabledbool"
                    :name="`left-${header}`"
                    :tabindex="`${index + 1}`"
                    :value="measures.left && measures.left[header] ? measures.left[header] : ''"
                    type="number"
                    @input="newVal => onChange(newVal, 'left', header)"
                  />
                </b-field>
              </td>
              <td v-for="shape in orderedByFitCodeShapes" v-bind:key="`left-${shape.id}-${header}`">
                <span
                  :class="[shape.fit_code === values.left.fit_code ? 'has-text-weight-bold' : 'has-text-grey-light']"
                >
                  {{ extractValue(shape, header, selectedSize.left) }}
                </span>
              </td>
              <td class="header">
                <strong>{{ $translate(header) | capitalize }}</strong>
              </td>
              <td v-for="shape in orderedByFitCodeShapes" v-bind:key="`right-${shape.id}-${header}`">
                <span
                  :class="[shape.fit_code === values.right.fit_code ? 'has-text-weight-bold' : 'has-text-grey-light']"
                >
                  {{ extractValue(shape, header, selectedSize.right) }}
                </span>
              </td>
              <td>
                <b-field
                  :message="errors.first(`right-${header}`)"
                  :type="{ 'is-danger': errors.has(`right-${header}`) }"
                >
                  <b-input
                    v-validate="`${config.isMeasurementRequired(header) ? 'required|' : ''}between:0,999|integer`"
                    :placeholder="'misure mm'"
                    :disabled="!selectedSize.right || disabledbool"
                    :name="`right-${header}`"
                    :tabindex="`${index + 1 + shapeTableHeaders.length}`"
                    :value="measures.right && measures.right[header] ? measures.right[header] : ''"
                    type="number"
                    @input="newVal => onChange(newVal, 'right', header)"
                  />
                </b-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeasurementsTable',
  props: ['shapes', 'measures', 'sizes', 'disabledbool', 'module'],
  inject: ['$validator'],
  data() {
    return {
      selectedSize: {},
      values: { left: {}, right: {} },
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.module]
    },
    shapeTableHeaders() {
      return this.shapes[0].type === 'low'
        ? this.$shapeTableHeadersLow[this.module].filter(header => header !== 'size')
        : this.$shapeTableHeadersHigh[this.module].filter(header => header !== 'size')
    },
    availableSizes() {
      if (this.sizes && this.sizes.min && this.sizes.max) {
        return [...new Set(this.shapes.flatMap(shape => shape.sizes.map(s => s.size)))].filter(
          size => size >= this.sizes.min && size <= this.sizes.max
        )
      } else {
        return [...new Set(this.shapes.flatMap(shape => shape.sizes.map(s => s.size)))]
      }
    },
    orderedByFitCodeShapes() {
      return this.shapes.slice().sort((a, b) => a.fit_code.localeCompare(b.fit_code))
    },
  },
  watch: {
    measures: {
      handler(newVal) {
        this.values = { ...this.values, ...newVal }
        if (this.values.left.size) {
          this.selectedSize.left = this.values.left.size
        }
        if (this.values.right.size) {
          this.selectedSize.right = this.values.right.size
        }
        this.dropInvalidFitCodes()
      },
      immediate: true,
    },
    shapes() {
      this.dropInvalidFitCodes()
    },
  },
  methods: {
    dropInvalidFitCodes() {
      if (!this.shapes || this.shapes.length === 0) return
      const codes = this.shapes.map(shape => shape.fit_code)
      for (const foot of ['left', 'right']) {
        const code = this.values[foot] ? this.values[foot].fit_code : null
        if (code && !codes.includes(code)) {
          this.values[foot] = { ...this.values[foot], fit_code: null }
          this.$emit('update', this.values, [null, foot])
        }
      }
    },
    extractValue(shape, header, size) {
      if (!size) return ''
      const foundSize = shape.sizes.find(s => s.size === size)
      if (!foundSize) return ''
      return foundSize[header]
    },
    onChange(newValue, foot, header) {
      this.values[foot] = { ...this.values[foot], [header]: newValue }
      this.$emit('update', this.values)
    },
    setSize(foot) {
      this.values[foot].size = this.selectedSize[foot]
      this.$emit('update', this.values)
    },
    copyToOtherFoot(foot) {
      if (foot === 'left') {
        this.selectedSize = { ...this.selectedSize, right: this.selectedSize[foot] }
        this.values.right = { ...this.values.left }
      }
      if (foot === 'right') {
        this.selectedSize = { ...this.selectedSize, left: this.selectedSize[foot] }
        this.values.left = { ...this.values.right }
      }
      this.$emit('update', this.values)
    },
  },
}
</script>
<style scoped>
.container >>> td input {
  text-align: center;
}
</style>
